export default __webpack_public_path__ + "static/media/pgmico(4).0e2d663b.png";